// ... imports
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const HeaderPart = () => {
  const [activeHeaderLink, setActiveHeaderLink] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavClick = (path, id) => {
    navigate(path);
    setActiveHeaderLink(id);
    setIsOpen(false);
  };

  // Prevent scrolling when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isOpen]);

  const navLinks = [
    { label: "ABOUT", path: "/About-me", id: "about-us" },
    { label: "JOURNEY", path: "/Education", id: "education" },
    { label: "WORK", path: "/MyProjects", id: "projects" },
    { label: "SKILLS", path: "/Education", id: "skills" },
    { label: "CONTACT", path: "/contact", id: "contact" },
  ];

  return (
    <>
      <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${isOpen ? 'bg-transparent' : 'bg-dark-bg/80 backdrop-blur-md border-b border-slate-800'}`}>
        <div className="container mx-auto flex justify-between items-center p-4">
          {/* Brand */}
          <div
            className="text-2xl font-black text-transparent bg-gradient-to-r from-primary-400 to-sky-400 bg-clip-text cursor-pointer font-display tracking-tighter"
            onClick={() => handleNavClick("/", "")}
          >
            MH.
          </div>

          {/* Mobile Toggle Button */}
          <button
            className="lg:hidden text-slate-200 hover:text-white transition-colors p-2 rounded-full hover:bg-slate-800 z-50 relative"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <CloseIcon fontSize="large" /> : <MenuIcon fontSize="large" />}
          </button>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex items-center gap-2">
            {navLinks.map((link) => (
              <li key={link.id}>
                <button
                  className={`text-sm font-bold px-5 py-2.5 rounded-full transition-all duration-300 relative group overflow-hidden
                    ${
                      activeHeaderLink === link.id
                        ? "text-white bg-primary-600 shadow-lg shadow-primary-500/20"
                        : "text-slate-400 hover:text-white hover:bg-slate-800"
                    }
                  `}
                  onClick={() => handleNavClick(link.path, link.id)}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Full Screen Mobile Modal */}
      <div
        className={`fixed inset-0 z-40 bg-dark-bg transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } lg:hidden flex flex-col items-center justify-center`}
      >
        <div className="flex flex-col space-y-8 text-center p-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              className={`text-3xl font-bold font-display tracking-tight transition-colors duration-300 ${
                activeHeaderLink === link.id
                  ? "text-primary-400"
                  : "text-slate-400 hover:text-white"
              }`}
              onClick={() => handleNavClick(link.path, link.id)}
            >
              {link.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default HeaderPart;
